<div class="row">
    <div class="col-md-1">
        <button class="btn btn-primary" type="button" [routerLink]="['/company','audits','add',companyId]">Add New Audit</button>
    </div>
</div>

<section class="panel">
    <header class="panel-heading">
        <h2 class="panel-title">Existing Audits</h2>
    </header>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>Audit</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let audit of audits;index as i">
                        <td>{{i+1}}</td>
                        <td>{{audit.title}}</td>
                        <td>{{audit.audit}}</td>
                        <td>{{audit.startDate}}</td>
                        <td>{{audit.endDate}}</td>
                        <td class="actions">
                            <a [routerLink]="['/company','audits', companyId,audit.id]" class="mb-1 mt-1 mr-2"><i class="fas fa-edit"></i></a>
                            <a *ngIf="!audit.hasUserAudit" (click)="selectedId=audit.id; confirmation.showMessage()" title="Delete Audit" class="mb-1 mt-1 mr-2"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteCompanyAudit()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this audit?'">
</app-confirmation-message>
